import { render, staticRenderFns } from "./key-value-table-row.vue?vue&type=template&id=8bf0cee0&scoped=true&"
import script from "./key-value-table-row.vue?vue&type=script&lang=js&"
export * from "./key-value-table-row.vue?vue&type=script&lang=js&"
import style0 from "./key-value-table-row.vue?vue&type=style&index=0&id=8bf0cee0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf0cee0",
  null
  
)

export default component.exports